<div class="subtopicResult mx-2-5">
  <div class="flex-display">
    <div *ngIf="area != null" class="searchTopicText bold"><span
        [innerHTML]="area | highlightSearchTerm: Searchterm"></span>&nbsp;<img _ngcontent-uoe-c167="" alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">&nbsp;
        <span *ngIf="topic != null" class="searchTopicText"><span class="right-Overlay"
          [innerHTML]="topic | highlightSearchTerm: Searchterm"></span>
        </span>
      </div>
   
  </div>
  <div class="mt_1 display-list font-blue" *ngFor="let topicRecord of topicResult">
    <div class="pb-1rem" *ngIf="topicRecord.source.area != null && topicRecord.source.topicId != null && topicRecord.source.topicTitle != null && topicRecord.source.subtopicId != null && topicRecord.source.subtopicTitle != null">

      <a *ngIf="topicRecord.source.subtopicId != null && topicRecord.source.subtopicTitle != null"
        href={{topicRecord.source.url}} (click)="openLinkById($event)" id={{topicRecord.source.url}}
        class="searchTopicText font-16 pdf-link mr_0_5rem">
        <span>{{topicRecord.source.subtopicId}}
          <span class="pdf-link mr_0_5rem"
            id={{topicRecord.source.url}}>{{topicRecord.source.subtopicTitle}}&nbsp;>&nbsp;
            <span *ngIf="topicRecord.source.sectionTitle != null" class="searchTopicText mr_0_5rem"
              [ngClass]="topicRecord.source.paragraphId == null? 'right-Overlay mr_0_5rem pdf-link':''"
              (click)="topicRecord.source.paragraphId == null?openLinkById($event):''"
              id={{topicRecord.source.url}}>{{topicRecord.source.sectionId}}&nbsp;
              <span class="pdf-link mr_0_5rem"
                id={{topicRecord.source.url}}>{{topicRecord.source.sectionTitle}}&nbsp;>&nbsp;
                <span *ngIf="topicRecord.source.paragraphId != null" id={{topicRecord.source.url}}
                  class="searchTopicText right-Overlay mr_0_5rem pdf-link" data-parent="searchPage" tabindex="0">
                  {{topicRecord.source.paragraphId}}</span>
              </span>
            </span>
          </span>
        </span>
      </a>
    </div>
  </div>
</div>
